var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultLinkBlockNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179145"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 146607",
    style: {
      fill: "#fff",
      stroke: "#e1e1e1",
      strokeDasharray: "2 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v39H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "link (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27356",
    d: "M20.513 5.916a3.13 3.13 0 0 0-4.434 0l.741.741a2.091 2.091 0 1 1 2.958 2.958L15.6 13.787a2.089 2.089 0 1 1-2.958-2.952l.735-.741-.735-.741-.741.741a3.133 3.133 0 0 0 4.444 4.418l4.173-4.173a3.13 3.13 0 0 0-.005-4.423z",
    transform: "translate(73.238 9.005)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27357",
    d: "M2.65 16.787a2.086 2.086 0 0 1 0-2.958l4.173-4.173a2.086 2.086 0 0 1 2.958 0 2.055 2.055 0 0 1 .595 1.487 2.086 2.086 0 0 1-.61 1.487l-1.107 1.121.741.741 1.106-1.106a3.139 3.139 0 0 0-4.44-4.439L1.893 13.12a3.107 3.107 0 0 0 2.222 5.326 3.166 3.166 0 0 0 2.233-.918l-.741-.741a2.086 2.086 0 0 1-2.958 0z",
    transform: "translate(78.029 7.554)",
    style: {
      fill: "#231f20"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLinkBlockNewIcon);
export default __webpack_public_path__ + "static/media/default_link_block_new_icon.57415f2e2b6537d9a060ee84e68c8146.svg";
export { ForwardRef as ReactComponent };